import { autoMount } from '../../../utils/autoMount';
import { Specials } from '../../../components/pages/specials';

autoMount({ Specials });
